"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PonziLeaderboardRank = void 0;
var PonziLeaderboardRank;
(function (PonziLeaderboardRank) {
    PonziLeaderboardRank["GOLD"] = "GOLD";
    PonziLeaderboardRank["SILVER"] = "SILVER";
    PonziLeaderboardRank["BRONZE"] = "BRONZE";
    PonziLeaderboardRank["BASIC"] = "BASIC";
})(PonziLeaderboardRank || (exports.PonziLeaderboardRank = PonziLeaderboardRank = {}));
//# sourceMappingURL=leaderboard.js.map